// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"445e6edf","455":"ffc5bdf8","686":"7994309b","977":"2156765c"}[chunkId] + ".chunk.js";
};